var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("Bar", {
    style: _vm.chartStyle,
    attrs: {
      options: _vm.chartOptions,
      data: _vm.chartData,
      id: _vm.chartId,
      "dataset-id-key": _vm.datasetIdKey,
      plugins: _vm.plugins,
      "css-classes": _vm.cssClasses,
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }